import { PipeTransform, Pipe } from '@angular/core';
import { StringHelper } from '../helpers/string-helper';

@Pipe({
  name: 'formatSummaryTime'
})
export class FormatSummaryTime implements PipeTransform {
  transform(installerHourBudget: number, installerMinuteBudget: number) {
    return StringHelper.join(
      [
        installerHourBudget == null ? null : installerHourBudget + ' h.',
        installerMinuteBudget == null ? null : installerMinuteBudget + ' min.'
      ].filter(s => s != null),
      ' '
    );
  }
}
